import React from "react";
import { PLANS_URL, TERMS_URL } from "../utils/support";

// The two boxes to tick before buying a website plan: the Terms and the plans have been read. checks: { terms, plans }
export const purchaseChecked = (checks) => Boolean(checks.terms && checks.plans);

export default function PurchaseChecks({ checks, onChange }) {
  const set = (key) => (e) => onChange({ ...checks, [key]: e.target.checked });
  return (
    <div className="purchase-checks">
      <label><input type="checkbox" checked={Boolean(checks.terms)} onChange={set("terms")} required /> I have read the <a href={TERMS_URL} target="_blank" rel="noreferrer">Terms &amp; Conditions</a></label>
      <label><input type="checkbox" checked={Boolean(checks.plans)} onChange={set("plans")} required /> I have checked the <a href={PLANS_URL} target="_blank" rel="noreferrer">Ownezzy plans</a></label>
    </div>
  );
}
